export class PackagePresenter {
  constructor(item) {
    this.id = item.id;
    this.name = item.name;
    this.imageUrl = item.imageUrl;
  }
}